import useModalReducer from "hooks/useModal";
import { useState, useEffect } from "react";
import { useCallback } from "react";
import { ViewClaimsModal } from "../ViewClaimsModal";
import { ClaimsTable } from "../ClaimsTable";
import { claimsTableModalEmitter } from "../ClaimsTable/config";

const AllClaimsPage = () => {
	const { state, dispatch, actions } = useModalReducer();

	const showModal = useCallback(
		(row) => {
			dispatch({
				type: actions.OPEN,
				payload: row,
			});
		},
		[dispatch, actions]
	);

	const hideModal = useCallback(
		(row) => {
			dispatch({ type: actions.CLOSE });
		},
		[dispatch, actions]
	);

	useEffect(() => {
		const unbind = claimsTableModalEmitter.on("showModal", showModal);
		return unbind;
	}, [showModal]);

	const [refetchCheck, setRefetchCheck] = useState(false);

	const refetch = useCallback(() => setRefetchCheck((prev) => !prev), []);

	return (
		<div className="relative content">
			<ViewClaimsModal state={state} showModal={showModal} hideModal={hideModal} payoutAction approveActions refetch={refetch} />
			<ClaimsTable self={false} showModal={showModal} parentRefetchCheck={refetchCheck} />
		</div>
	);
};

export default AllClaimsPage;
